import React, { useEffect, useState } from 'react'


import { DualSlider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func,
  number,
  bool,
  array,
  oneOfType,
  string,
} from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

function PriceSlider({
  maxPriceThreshold,
  minPriceThreshold,
  removeFreeFilter,
  setSelectedFilters,
  withTitleDivider = false,
  rangeFilters = EMPTY_ARRAY,
  selectedPriceRangeFilters = EMPTY_ARRAY,
  setShouldResetPriceRange,
  shouldResetPriceRange,
  handleEnterKeyPress = NOOP,
  trackFilterChange,
  locale = 'en',
}) {
  const [previousFrom, setPreviousFrom] = useState()
  const [previousTo, setPreviousTo] = useState()

  const title = i18n.t('listingPage.filters.customPriceRange', { ns: 'rails', lng: locale })

  useEffect(() => {
    if (!selectedPriceRangeFilters.length || previousFrom || previousTo) {
      return
    }

    const customPriceRange = selectedPriceRangeFilters.find(value => !rangeFilters.includes(value))
    if (customPriceRange) {
      const [from, to] = customPriceRange.split('_').slice(1)
      setPreviousFrom(Number(from))
      setPreviousTo(Number(to))
    }
  }, [selectedPriceRangeFilters])

  useEffect(() => {
    if (shouldResetPriceRange) {
      setPreviousFrom(minPriceThreshold)
      setPreviousTo(maxPriceThreshold)
      setShouldResetPriceRange(false)
    }
  }, [shouldResetPriceRange])

  function handlePriceChange({ min, max }) {
    const isDefaultValue = min === minPriceThreshold && max === maxPriceThreshold
    const previousValue = `range_${previousFrom}_${previousTo}`
    const newFilter = selectedPriceRangeFilters.length > 0
      ? selectedPriceRangeFilters.filter(value => value !== previousValue)
      : []

    if (isDefaultValue) {
      setSelectedFilters({ name: 'priceRange', value: newFilter })
      setPreviousFrom(min)
      setPreviousTo(max)
      window.removeCurrentSearchFilter({ name: 'polygonRange' })
      return
    }

    removeFreeFilter()

    const newMinPrice = Math.max(min, minPriceThreshold)
    const newMaxPrice = Math.min(max, maxPriceThreshold)
    const newValue = `range_${newMinPrice}_${newMaxPrice}`

    setSelectedFilters({ name: 'priceRange', value: [...newFilter, newValue] })
    trackFilterChange({ name: 'priceRange', value: newValue })
    setPreviousFrom(min)
    setPreviousTo(max)
  }

  return (
    <div className="metaverse-listing__price-slider">
      <DualSlider
        id="price-slider"
        minThreshold={minPriceThreshold}
        maxThreshold={maxPriceThreshold}
        max={Math.min(
          Number(previousTo || maxPriceThreshold),
          maxPriceThreshold
        )}
        min={Math.max(
          Number(previousFrom || minPriceThreshold),
          minPriceThreshold
        )}
        name="price-slider"
        onChange={handlePriceChange}
        title={title}
        withSliderOnTop
        withMarkers
        withTextAlignCenter
        isCurrency
        withTitleDivider={withTitleDivider}
        onEnterKeyPress={handleEnterKeyPress}
      />
    </div>
  )
}

PriceSlider.propTypes = {
  setSelectedFilters: func.isRequired,
  maxPriceThreshold: number.isRequired,
  minPriceThreshold: number.isRequired,
  removeFreeFilter: func.isRequired,
  withTitleDivider: bool,
  rangeFilters: array,
  selectedPriceRangeFilters: oneOfType([array, string]),
  setShouldResetPriceRange: func.isRequired,
  shouldResetPriceRange: bool.isRequired,
  handleEnterKeyPress: func,
  trackFilterChange: func.isRequired,
  locale: string,
}

const mapStateToProps = (
  {
    maxPriceThreshold,
    minPriceThreshold,
    selectedFilters,
    setMultipleFilters,
    setSelectedFilters,
    filtersOptions,
    setShouldResetPriceRange,
    shouldResetPriceRange,
    trackFilterChange,
    locale,
  },
) => {
  const rangeFilters = filtersOptions.priceRange.filters.map(({ value }) => value)
  const selectedPriceRangeFilters = selectedFilters.priceRange

  return {
    maxPriceThreshold,
    minPriceThreshold,
    setMultipleFilters,
    setSelectedFilters,
    rangeFilters,
    selectedPriceRangeFilters,
    setShouldResetPriceRange,
    shouldResetPriceRange,
    trackFilterChange,
    locale,
  }
}

export default WithTriangleUiContext(mapStateToProps)(PriceSlider)
